// extracted by mini-css-extract-plugin
export default {"advtVideo":"AdvtVideo_advtVideo__7FwvI"};